//** Constants Branches */
export const LIST_BRANCH_HEALTHCARE_REQUEST = 'LIST_BRANCH_HEALTHCARE_REQUEST'
export const LIST_BRANCH_HEALTHCARE_SUCCESS = 'LIST_BRANCH_HEALTHCARE_SUCCESS'
export const LIST_BRANCH_HEALTHCARE_FAIL = 'LIST_BRANCH_HEALTHCARE_FAIL'

export const LIST_MCU_TEAM_REQUEST = 'LIST_MCU_TEAM_REQUEST'
export const LIST_MCU_TEAM_SUCCESS = 'LIST_MCU_TEAM_SUCCESS'
export const LIST_MCU_TEAM_FAIL = 'LIST_MCU_TEAM_FAIL'

export const LIST_MCU_TEAM_SUMMARY_REQUEST = 'LIST_MCU_TEAM_SUMMARY_REQUEST'
export const LIST_MCU_TEAM_SUMMARY_SUCCESS = 'LIST_MCU_TEAM_SUMMARY_SUCCESS'
export const LIST_MCU_TEAM_SUMMARY_FAIL = 'LIST_MCU_TEAM_SUMMARY_FAIL'

export const LIST_HEALTHCARE_SUPPORT_REQUEST = 'LIST_HEALTHCARE_SUPPORT_REQUEST'
export const LIST_HEALTHCARE_SUPPORT_SUCCESS = 'LIST_HEALTHCARE_SUPPORT_SUCCESS'
export const LIST_HEALTHCARE_SUPPORT_FAIL = 'LIST_HEALTHCARE_SUPPORT_FAIL'

export const CREATE_BRANCH_HEALTHCARE_REQUEST = 'CREATE_BRANCH_HEALTHCARE_REQUEST'
export const CREATE_BRANCH_HEALTHCARE_SUCCESS = 'CREATE_BRANCH_HEALTHCARE_SUCCESS'
export const CREATE_BRANCH_HEALTHCARE_FAIL = 'CREATE_BRANCH_HEALTHCARE_FAIL'

export const DETAIL_MCU_TEAM_REQUEST = 'DETAIL_MCU_TEAM_REQUEST' 
export const DETAIL_MCU_TEAM_SUCCESS = 'DETAIL_MCU_TEAM_SUCCESS' 
export const DETAIL_MCU_TEAM_FAIL = 'DETAIL_MCU_TEAM_FAIL' 

export const DETAIL_BRANCH_HEALTHCARE_REQUEST = 'DETAIL_BRANCH_HEALTHCARE_REQUEST'
export const DETAIL_BRANCH_HEALTHCARE_SUCCESS = 'DETAIL_BRANCH_HEALTHCARE_SUCCESS'
export const DETAIL_BRANCH_HEALTHCARE_FAIL = 'DETAIL_BRANCH_HEALTHCARE_FAIL'

export const UPDATE_BRANCH_HEALTHCARE_REQUEST = 'UPDATE_BRANCH_HEALTHCARE_REQUEST'
export const UPDATE_BRANCH_HEALTHCARE_SUCCESS = 'UPDATE_BRANCH_HEALTHCARE_SUCCESS'
export const UPDATE_BRANCH_HEALTHCARE_FAIL = 'UPDATE_BRANCH_HEALTHCARE_FAIL'

export const DELETE_BRANCH_HEALTHCARE_REQUEST = 'DELETE_BRANCH_HEALTHCARE_REQUEST'
export const DELETE_BRANCH_HEALTHCARE_SUCCESS = 'DELETE_BRANCH_HEALTHCARE_SUCCESS'
export const DELETE_BRANCH_HEALTHCARE_FAIL = 'DELETE_BRANCH_HEALTHCARE_FAIL'
